<template>
    <va-edit-layout>
        <RefundEventShipmentItemCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></RefundEventShipmentItemCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
